import { app } from '../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('user.shared-accounts.access-requests', {
        url: '/access-requests',
        views: {
            '': 'accessRequests',
            'header@user': 'userSharedAccountsHeader',
        },
        resolve: {requests},
    })
}

/** @ngInject */
function requests(AccessRequestsService) {
    return AccessRequestsService.getRequests();
}



// WEBPACK FOOTER //
// ./src/portal/states/user/access-requests/access-requests.state.js